import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import useMouseOver from '../Hooks/useMouseOver';

/**
Il componente visualizza un testo in pop over al mouse over.

_ATTENZIONE_ l'attuale implementazione ha dei problemi con certi tipi di overflow.
Può accadere infatti che il testo in pop over venga "coperto" da contenuti al di fuori del div che lo contiene.
Questo vale per tutti i componenti che lo utilizano (Ellipsis, InfoToolip).
 */
const Tooltip = ({
  children, left, right, top, content, enableFunction, className,
}) => {
  const [mostraInfo, onMouseOver, onMouseOut] = useMouseOver();

  const enable = !enableFunction || enableFunction();

  const classes = cns(
    'infoTooltip',
    {
      'infoTooltip--left': left,
      'infoTooltip--right': right,
      'infoTooltip--top': top,
      'infoTooltip--enable': enable,
    },
    className,
  );

  return (
    <span
      className={classes}
      data-clickable="false"
      onMouseOver={onMouseOver}
      onFocus={onMouseOver}
      onMouseOut={onMouseOut}
      onBlur={onMouseOut}
    >
      {children}
      {mostraInfo && enable && (
        <span
          className="infoTooltip__content"
          data-clickable="false"
        >
          {content}
        </span>
      )}
    </span>
  );
};

Tooltip.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.node,
  /** Indica se aprire il contenuto spostato verso sinistra */
  left: PropTypes.bool,
  /** Indica se aprire il contenuto spostato verso destra */
  right: PropTypes.bool,
  /** Mostra il contenuto sopra */
  top: PropTypes.bool,
  /** Indica il testo del tooltip */
  content: PropTypes.node.isRequired,
  /** funciton per indicare se abilitare o no il tooltip */
  enableFunction: PropTypes.func,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
};

Tooltip.defaultProps = {
  children: null,
  left: false,
  right: false,
  top: false,
  enableFunction: null,
  className: null,
};

export default Tooltip;
